import Cookies from 'js-cookie';

import useAuthenticatedUser from '../authenticated-user';

const ANONYMOUS_COOKIE_NAME = 'letudiant_algolia_anonymous_user_token';

const AUTHENTICATED_COOKIE_NAME = 'letudiant_algolia_authenticated_user_token';

const cookieApi = Cookies.withAttributes({
    secure: true,
    domain: import.meta.env.VITE_ALGOLIA_COOKIE_DOMAIN,
    expires: 365,
});

export default (controller) => {
    const generateAuthenticatedUserToken = (user) => {
        cookieApi.set(AUTHENTICATED_COOKIE_NAME, `user-${user.content.user.hashed_id}`);
    };

    const removeAuthenticatedUserToken = () => {
        cookieApi.remove(AUTHENTICATED_COOKIE_NAME);
    };

    const generateAnonymousUserToken = () => {
        if (cookieApi.get(ANONYMOUS_COOKIE_NAME)) {
            return;
        }

        cookieApi.set(ANONYMOUS_COOKIE_NAME, crypto.randomUUID());
    };

    const getAnonymousUserToken = () => {
        return Cookies.get(ANONYMOUS_COOKIE_NAME) || generateAnonymousUserToken();
    };

    const getAuthenticatedUserToken = () => {
        return Cookies.get(AUTHENTICATED_COOKIE_NAME);
    };

    const hasAuthenticatedUserToken = () => {
        return !!getAuthenticatedUserToken();
    };

    const generateUserToken = (user) => {
        generateAnonymousUserToken();

        if (user?.content?.connected) {
            generateAuthenticatedUserToken(user);

            return;
        }

        removeAuthenticatedUserToken();
    };

    useAuthenticatedUser(controller, generateUserToken);

    Object.assign(controller, {
        getAnonymousUserToken,
        hasAuthenticatedUserToken,
        getAuthenticatedUserToken,
    });
};
